import React from 'react';
import vaultArt from './greedy-vault.jpg';

export const GreedyLandingArt: React.FC = () => (
  <div className="greedy-landing-art">
    <img className="greedy-vault-hero" src={vaultArt} alt="" />
  </div>
);
